import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import * as React from 'react';
import { m, l, xl } from '@drone-js/media-query';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var Token = /*#__PURE__*/function (Token) {
  Token["Medium"] = "m";
  Token["Large"] = "l";
  Token["ExtraLarge"] = "xl";
  return Token;
}(Token || {});
var defaultContext = {
  m: true,
  l: false,
  xl: false
};
var MediaQueryContext = /*#__PURE__*/React.createContext(defaultContext);
var useMediaQueryContext = function useMediaQueryContext() {
  return React.useContext(MediaQueryContext);
};
var MediaQueryContextProvider = /*#__PURE__*/React.memo(function (_ref) {
  var children = _ref.children;
  var mediaQueryLists = React.useMemo(function () {
    var _window, _window2, _window3;
    return new Map([[Token.Medium, (_window = window) === null || _window === void 0 ? void 0 : _window.matchMedia(m.get())], [Token.Large, (_window2 = window) === null || _window2 === void 0 ? void 0 : _window2.matchMedia(l.get())], [Token.ExtraLarge, (_window3 = window) === null || _window3 === void 0 ? void 0 : _window3.matchMedia(xl.get())]]);
  }, []);
  var _React$useState = React.useState(function () {
      var state = _objectSpread({}, defaultContext);
      mediaQueryLists.forEach(function (mediaQueryList, token) {
        state[token] = mediaQueryList.matches;
      });
      return state;
    }),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    context = _React$useState2[0],
    setContext = _React$useState2[1];
  React.useEffect(function () {
    var listeners = new Map();
    mediaQueryLists.forEach(function (mediaQueryList, token) {
      var listener = function listener(event) {
        return setContext(function (before) {
          return _objectSpread(_objectSpread({}, before), {}, _defineProperty({}, token, event.matches));
        });
      };
      mediaQueryList.addEventListener('change', listener);
      listeners.set(token, [mediaQueryList, listener]);
    });
    return function () {
      listeners.forEach(function (_ref2) {
        var _ref3 = _slicedToArray(_ref2, 2),
          mediaQueryList = _ref3[0],
          listener = _ref3[1];
        mediaQueryList.removeEventListener('change', listener);
      });
    };
  }, [mediaQueryLists]);
  return /*#__PURE__*/React.createElement(MediaQueryContext.Provider, {
    value: context
  }, children);
});
MediaQueryContextProvider.displayName = 'MediaQueryContextProvider';

export { MediaQueryContextProvider, Token as MediaQueryToken, defaultContext as defaultMediaQuery, useMediaQueryContext };
//# sourceMappingURL=MediaQuery.js.map
